import { AppointmentPatient } from '@dreryk/egabinet-appointment-frontend-api';

import { TextView } from '@dreryk/react-components';
import { patientNameFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AppointmentPatientTextViewProps = Readonly<{ patient: AppointmentPatient }>;

export const AppointmentPatientTextView = (props: AppointmentPatientTextViewProps): JSX.Element => {
   return (
      <TextView testId={'patient'} label={translationKeys.patient}>
         {patientNameFormatter(props.patient)}
      </TextView>
   );
};
